/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { MultiWrapperComponent } from 'src/app/modules/ticket-edit/components/multi-wrapper/multi-wrapper.component';
import { TicketEditBaseComponent } from 'src/app/modules/ticket-edit/components/ticket-edit-base/ticket-edit-base.component';
import * as appStrings from '@touchplan/strings';

@Component({
	selector: 'ticket-wbs-code',
	templateUrl: './ticket-wbs-code.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WbsCodeComponent extends TicketEditBaseComponent implements OnInit {
	public appStrings = appStrings;

	constructor(
		@Self() @Optional() public override control: NgControl,
		@Optional() public override multiWrapper: MultiWrapperComponent,
		@Optional() protected override cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public override ngOnInit() {
		super.ngOnInit();

		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val) => {
			this.onChange(val);
		});
	}
}
